import type { LocationQueryValue } from "vue-router";

const GUID_REGEX =
	/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
const GUID_EMPTY = "00000000-0000-0000-0000-000000000000";

export function getSingleQueryParam(
	value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
	if (Array.isArray(value)) {
		const firstValue = value[0];
		return typeof firstValue === "string" ? firstValue : undefined;
	}

	return typeof value === "string" ? value : undefined;
}

export function allowGuidInQueryParam(
	value: LocationQueryValue | LocationQueryValue[] | undefined,
): string | undefined {
	const singleValue = getSingleQueryParam(value);

	if (
		singleValue === GUID_EMPTY ||
		(singleValue && GUID_REGEX.test(singleValue))
	) {
		return singleValue;
	}

	return undefined;
}
